import React, { useState, memo } from 'react';
import { Text, View, Title } from '@constants/Themed';
import { Alert, FlatList } from 'react-native';
import Checkbox from 'expo-checkbox';
import styles from '@stylesheet';
import { themeSelector } from '@reduxLocal/selectors/themeSelector';

const RenderCalendarList = ({ item, index, handleSelection, listLength, alreadyImported }) => {
  const [checked, setChecked] = useState(alreadyImported || false);
  const theme = themeSelector();

  const handleSelect = (value) => {
    if (value && listLength >= 3) {
      Alert.alert('Limit Reached', 'You can only select 3 calendars at this moment, sacrifices must be made');
      return;
    }
    setChecked(value);
    handleSelection(item);
  }

  return (
    <View style={{ gap: 20, borderRadius: 10, padding: 10, flexDirection: 'row', backgroundColor: index % 2 ? (theme ? '#ececec' : '#333333') : undefined }}>
      <Checkbox style={styles.centerEverything} hitSlop={10} value={checked} onValueChange={handleSelect} />
      <View style={{ backgroundColor: 'transparent' }}>
        <Title>{item.source.name}</Title>
        <Text>{item.title}</Text>
        <Text>{item.type}</Text>
      </View>
    </View>
  )
};
export default memo(RenderCalendarList);